import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, UntypedFormGroup, FormArray, UntypedFormControl, Validators } from '@angular/forms';
@Component({
    selector: 'app-task-event',
    templateUrl: './task-event.component.html',
    styleUrls: ['./task-event.component.css'],
    standalone: false
})
export class TaskEventComponent implements OnInit, OnChanges
{

	@Input() form1: UntypedFormGroup;
	@Input() taskApi: any;
	@Input() taskId: any;
	@Input() formReadOnly: any;
	@Output() messageEvent = new EventEmitter<string>();

	intervalTaskRepeat: any;
	intervalTaskStatus: any;
	timeZones = [
		{ value: 'US/Hawaii', name: 'HST' },
		{ value: 'US/Pacific', name: 'PST' },
		{ value: 'US/Mountain', name: 'MST' },
		{ value: 'US/Central', name: 'CST' },
		{ value: 'US/Eastern', name: 'EST' },
	];

	time = [
		{ value: '12:00 AM', name: '12:00 AM' },
		{ value: '12:15 AM', name: '12:15 AM' },
		{ value: '12:30 AM', name: '12:30 AM' },
		{ value: '12:45 AM', name: '12:45 AM' },
		{ value: '1:00 AM', name: '1:00 AM' },
		{ value: '1:15 AM', name: '1:15 AM' },
		{ value: '1:30 AM', name: '1:30 AM' },
		{ value: '1:45 AM', name: '1:45 AM' },
		{ value: '2:00 AM', name: '2:00 AM' },
		{ value: '2:15 AM', name: '2:15 AM' },
		{ value: '2:30 AM', name: '2:30 AM' },
		{ value: '2:45 AM', name: '2:45 AM' },
		{ value: '3:00 AM', name: '3:00 AM' },
		{ value: '3:15 AM', name: '3:15 AM' },
		{ value: '3:30 AM', name: '3:30 AM' },
		{ value: '3:45 AM', name: '3:45 AM' },
		{ value: '4:00 AM', name: '4:00 AM' },
		{ value: '4:15 AM', name: '4:15 AM' },
		{ value: '4:30 AM', name: '4:30 AM' },
		{ value: '4:45 AM', name: '4:45 AM' },
		{ value: '5:00 AM', name: '5:00 AM' },
		{ value: '5:15 AM', name: '5:15 AM' },
		{ value: '5:30 AM', name: '5:30 AM' },
		{ value: '5:45 AM', name: '5:45 AM' },
		{ value: '6:00 AM', name: '6:00 AM' },
		{ value: '6:15 AM', name: '6:15 AM' },
		{ value: '6:30 AM', name: '6:30 AM' },
		{ value: '6:45 AM', name: '6:45 AM' },
		{ value: '7:00 AM', name: '7:00 AM' },
		{ value: '7:15 AM', name: '7:15 AM' },
		{ value: '7:30 AM', name: '7:30 AM' },
		{ value: '7:45 AM', name: '7:45 AM' },
		{ value: '8:00 AM', name: '8:00 AM' },
		{ value: '8:15 AM', name: '8:15 AM' },
		{ value: '8:30 AM', name: '8:30 AM' },
		{ value: '8:45 AM', name: '8:45 AM' },
		{ value: '9:00 AM', name: '9:00 AM' },
		{ value: '9:15 AM', name: '9:15 AM' },
		{ value: '9:30 AM', name: '9:30 AM' },
		{ value: '9:45 AM', name: '9:45 AM' },
		{ value: '10:00 AM', name: '10:00 AM' },
		{ value: '10:15 AM', name: '10:15 AM' },
		{ value: '10:30 AM', name: '10:30 AM' },
		{ value: '10:45 AM', name: '10:45 AM' },
		{ value: '11:00 AM', name: '11:00 AM' },
		{ value: '11:15 AM', name: '11:15 AM' },
		{ value: '11:30 AM', name: '11:30 AM' },
		{ value: '11:45 AM', name: '11:45 AM' },
		{ value: '', name: '' },
		{ value: '12:00 PM', name: '12:00 PM' },
		{ value: '12:15 PM', name: '12:15 PM' },
		{ value: '12:30 PM', name: '12:30 PM' },
		{ value: '12:45 PM', name: '12:45 PM' },
		{ value: '1:00 PM', name: '1:00 PM' },
		{ value: '1:15 PM', name: '1:15 PM' },
		{ value: '1:30 PM', name: '1:30 PM' },
		{ value: '1:45 PM', name: '1:45 PM' },
		{ value: '2:00 PM', name: '2:00 PM' },
		{ value: '2:15 PM', name: '2:15 PM' },
		{ value: '2:30 PM', name: '2:30 PM' },
		{ value: '2:45 PM', name: '2:45 PM' },
		{ value: '3:00 PM', name: '3:00 PM' },
		{ value: '3:15 PM', name: '3:15 PM' },
		{ value: '3:30 PM', name: '3:30 PM' },
		{ value: '3:45 PM', name: '3:45 PM' },
		{ value: '4:00 PM', name: '4:00 PM' },
		{ value: '4:15 PM', name: '4:15 PM' },
		{ value: '4:30 PM', name: '4:30 PM' },
		{ value: '4:45 PM', name: '4:45 PM' },
		{ value: '5:00 PM', name: '5:00 PM' },
		{ value: '5:15 PM', name: '5:15 PM' },
		{ value: '5:30 PM', name: '5:30 PM' },
		{ value: '5:45 PM', name: '5:45 PM' },
		{ value: '6:00 PM', name: '6:00 PM' },
		{ value: '6:15 PM', name: '6:15 PM' },
		{ value: '6:30 PM', name: '6:30 PM' },
		{ value: '6:45 PM', name: '6:45 PM' },
		{ value: '7:00 PM', name: '7:00 PM' },
		{ value: '7:15 PM', name: '7:15 PM' },
		{ value: '7:30 PM', name: '7:30 PM' },
		{ value: '7:45 PM', name: '7:45 PM' },
		{ value: '8:00 PM', name: '8:00 PM' },
		{ value: '8:15 PM', name: '8:15 PM' },
		{ value: '8:30 PM', name: '8:30 PM' },
		{ value: '8:45 PM', name: '8:45 PM' },
		{ value: '9:00 PM', name: '9:00 PM' },
		{ value: '9:15 PM', name: '9:15 PM' },
		{ value: '9:30 PM', name: '9:30 PM' },
		{ value: '9:45 PM', name: '9:45 PM' },
		{ value: '10:00 PM', name: '10:00 PM' },
		{ value: '10:15 PM', name: '10:15 PM' },
		{ value: '10:30 PM', name: '10:30 PM' },
		{ value: '10:45 PM', name: '10:45 PM' },
		{ value: '11:00 PM', name: '11:00 PM' },
		{ value: '11:15 PM', name: '11:15 PM' },
		{ value: '11:30 PM', name: '11:30 PM' },
		{ value: '11:45 PM', name: '11:45 PM' }
	];


	validationMessages = {
		'eventStartDate': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],
		'eventStartTime': [],
		'eventEndDate': [
			{ type: 'maxlength', message: '80 characters maximum' }
		],
		'eventEndTime': [],
		'location': [
			{ type: 'required', message: 'Location is required' },
		],
		'timeZone': [],
	};


	constructor() { }

	ngOnInit()
	{
		console.log('crap' + JSON.stringify(this.taskApi));
		// this.form1.addControl('eventStartDate', new FormControl('', Validators.required));
		this.form1.addControl('eventStartDate', new UntypedFormControl(''));
		this.form1.addControl('eventStartTime', new UntypedFormControl(''));
		this.form1.addControl('eventEndDate', new UntypedFormControl(''));
		this.form1.addControl('eventEndTime', new UntypedFormControl(''));
		this.form1.addControl('location', new UntypedFormControl(''));
		this.form1.addControl('timeZone', new UntypedFormControl('US/Pacific'));

		// repeat
		if (this.taskApi)
		{
			this.form1.patchValue(this.taskApi);

			this.intervalTaskRepeat = (this.taskApi.intervalTaskRepeat ? this.taskApi.intervalTaskRepeat : '');
			this.intervalTaskStatus = (this.taskApi.intervalTaskStatus ? this.taskApi.intervalTaskStatus : '');

			// set time to blank if null so it defaults to middle of drop down select
			if (!this.form1.controls['eventStartTime'].value)
			{
				this.form1.controls['eventStartTime'].setValue('');
			}
			if (!this.form1.controls['eventEndTime'].value)
			{
				this.form1.controls['eventEndTime'].setValue('');
			}
		}
	}
	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.form1 !== undefined)
		{
			this.form1.patchValue(this.form1.value);
		}
	}
}
